// ── Vipimo vya Pamoja ───────────────────────────────────────────────────
// Kwa sababu bloku ya chess na lifeskills ni ILEILE kwa programu zote,
// tunaweza kuhesabu vipimo vinavyolinganishwa moja kwa moja kati ya
// programu — na kwa programu zitakazoongezwa baadaye, bila kubadilisha
// chochote hapa.

export const CHESS_METRICS = [
  { key: 'rSheria', label: 'Sheria za mchezo' },
  { key: 'rTactics', label: 'Mbinu (tactics)' },
  { key: 'rFocus', label: 'Umakini' },
  { key: 'rSport', label: 'Nidhamu' },
  { key: 'rGrowth', label: 'Maendeleo ya jumla' },
];

export const LIFESKILLS_METRICS = [
  { key: 'lsParticipation', label: 'Ushiriki' },
  { key: 'lsBehaviour', label: 'Tabia' },
  { key: 'lsTeamwork', label: 'Ushirikiano' },
];

function avg(nums) {
  const list = nums.filter(n => typeof n === 'number' && n > 0);
  if (!list.length) return null;
  return Math.round((list.reduce((a, b) => a + b, 0) / list.length) * 10) / 10;
}

function rate(values, match) {
  const list = values.filter(v => v);
  if (!list.length) return null;
  return Math.round((list.filter(v => v === match).length / list.length) * 100);
}

// Vipimo vya kundi lolote la ripoti binafsi
export function summarise(reports) {
  const v = reports.map(r => r.values || {});

  const chess = {};
  CHESS_METRICS.forEach(m => { chess[m.key] = avg(v.map(x => Number(x[m.key]))); });

  const life = {};
  LIFESKILLS_METRICS.forEach(m => { life[m.key] = avg(v.map(x => Number(x[m.key]))); });

  const played = v.reduce((a, x) => a + (Number(x.gamesPlayed) || 0), 0);
  const won = v.reduce((a, x) => a + (Number(x.gamesWon) || 0), 0);

  const levels = {};
  v.forEach(x => { if (x.chessLevel) levels[x.chessLevel] = (levels[x.chessLevel] || 0) + 1; });

  return {
    count: reports.length,
    chess,
    life,
    chessAvg: avg(CHESS_METRICS.map(m => chess[m.key])),
    lifeAvg: avg(LIFESKILLS_METRICS.map(m => life[m.key])),
    chessAttendance: rate(v.map(x => x.chessAttendance), 'Alihudhuria zote'),
    lifeAttendance: rate(v.map(x => x.lsAttendance), 'Alihudhuria zote'),
    gamesPlayed: played,
    winRate: played ? Math.round((won / played) * 100) : null,
    levels,
  };
}

// Mwenendo wa wiki kwa wiki (wastani wa alama za chess na lifeskills)
export function weeklyTrend(reports) {
  const byWeek = {};
  reports.forEach(r => {
    const k = r.weekKey || '—';
    (byWeek[k] = byWeek[k] || []).push(r);
  });
  return Object.keys(byWeek).sort().map(k => {
    const s = summarise(byWeek[k]);
    return { weekKey: k, chess: s.chessAvg, life: s.lifeAvg, count: s.count };
  });
}
